import React from "react";

interface NoAccountCardHighlightData {
  highlightCount: number;
  highlightCard: () => void;
}

export const NoAccountCardHighlightContext =
  React.createContext<NoAccountCardHighlightData>({
    highlightCount: 0,
    highlightCard: () => undefined,
  });
